var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 60,
    viewBox: "0 0 78 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9L27.6017 34.5047V59L36.3983 52.3184V34.5048L58 9H6Z",
    fill: "#E9EBF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.677 9H58.323L62.4987 4.29404C63.6469 3.00002 62.6958 1.00001 60.9322 1L3.06778 1C1.30422 1 0.353125 3.00002 1.50132 4.29403L5.677 9Z",
    fill: "#A2ABCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.30604 3.74737C1.73501 3.08166 2.20802 2.05275 3.08508 2.05275L60.64 2.05276C61.5171 2.05276 61.9901 3.08167 61.4191 3.74737L57.5729 8.23122H6.15218L2.30604 3.74737ZM3.08508 0C0.45388 0 -0.965122 3.08673 0.747963 5.08385L4.88939 9.91194C4.8933 9.91667 4.89726 9.92137 4.90127 9.92604L26.407 34.9975V58.9737C26.407 59.3624 26.6266 59.7178 26.9744 59.8917C27.3221 60.0655 27.7382 60.028 28.0492 59.7948L36.9074 53.1511C37.1658 52.9573 37.3179 52.6531 37.3179 52.33V34.9975L58.8237 9.92604C58.8258 9.9236 58.8279 9.92114 58.83 9.91868L62.9772 5.08386C64.6902 3.08673 63.2712 5.2612e-06 60.64 5.01649e-06L3.08508 0ZM28.2124 33.9494L7.91295 10.2842H55.812L35.5125 33.9494C35.3529 34.1355 35.2652 34.3725 35.2652 34.6176V51.8168L28.4597 56.9209V34.6176C28.4597 34.3725 28.372 34.1354 28.2124 33.9494Z",
    fill: "#282D61"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19V39",
    stroke: "#282D61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77 29H57",
    stroke: "#282D61",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFilter);
export default __webpack_public_path__ + "static/media/add-filter.67c9bd0ae67a380cc3b0c5511f9cdf6c.svg";
export { ForwardRef as ReactComponent };